import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, useMediaQuery, useTheme, } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useLocation, useNavigate } from "react-router-dom";
import AuthWrapper from "./AuthWrapper";
import { ContentBox } from "./Login";
import { useForm } from "react-hook-form";
import { HInput } from "@ui/components/inputs/HInput";
import { PButton } from "@ui/components/buttons/PButton";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { fetchAllCompaniesAsync } from "@application/features/company/companyThunk";
import { validateInitialRegistrationAsync } from "@application/features/Event/EventThunk";
import { HAutocomplete } from "@ui/components/inputs/HAutoComplete";
import { ArrowRightIcon } from "@ui/icons/CustomIcons";
export const Registeration = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { state } = useLocation();
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only("xs"));
    const isMdUp = useMediaQuery(theme.breakpoints.up("xs"));
    const isBelow1024 = useMediaQuery(theme.breakpoints.down(1025));
    const isBelow390 = useMediaQuery(theme.breakpoints.down(391));
    const { allCompanies } = useAppSelector((state) => state.company);
    const isSmallScreen = useMediaQuery("(max-width:900px)");
    const eventData = state?.eventData;
    const { control, handleSubmit, formState: { errors }, trigger, reset, watch, } = useForm({
        mode: "onChange",
    });
    const emailValue = watch("emailAddress")?.trim()?.toLowerCase();
    const companyOptions = allCompanies?.map((company) => ({
        label: company.name,
        value: company.id,
    })) || [];
    useEffect(() => {
        if (!eventData) {
            navigate("/event/login", { replace: true });
        }
        else {
            dispatch(fetchAllCompaniesAsync());
        }
    }, [navigate]);
    const onSubmit = (data) => {
        data.eventId = eventData.eventId;
        dispatch(validateInitialRegistrationAsync(data))
            .unwrap()
            .then((response) => {
            if (response && response.isSuccess) {
                toast.success(response.message);
                navigate("/event/welcome");
                reset({
                    firstName: "",
                    middleName: "",
                    lastName: "",
                    emailAddress: "",
                    primaryCompanyId: "",
                });
            }
            else {
                toast.error(response.message);
            }
        })
            .catch((error) => { });
    };
    return (_jsx(AuthWrapper, { children: _jsxs(ContentBox, { maxWidth: isSmallScreen ? "100%" : isBelow1024 ? 438 : 590, padding: isBelow390 ? '20px 24px' : isBelow1024 ? "32px" : "48px", overflow: "auto", sx: {
                scrollbarWidth: "none", // For Firefox
                msOverflowStyle: "none", // For IE and Edge
                "&::-webkit-scrollbar": {
                    display: "none",
                },
            }, children: [_jsxs(Box, { maxHeight: isMdUp ? "calc(100svh - 48px)" : undefined, children: [_jsx(Typography, { fontFamily: "SuisseIntl", fontWeight: 500, variant: "h5", color: "#00244D", children: t("eventregister.registerHeading") }), _jsxs(Grid, { my: 2.5, container: true, spacing: 1, children: [_jsx(Grid, { size: { xs: 12, sm: 12 }, children: _jsx(HAutocomplete, { label: t("formFields.selectCompany"), name: "primaryCompanyId", control: control, options: companyOptions, error: errors?.primaryCompanyId?.message, rules: {
                                            required: {
                                                value: true,
                                                message: "validations.companyRequired",
                                            },
                                        } }) }), _jsx(Grid, { size: { xs: 12, sm: 12 }, children: _jsx(HInput, { label: t("formFields.firstName"), name: "firstName", control: control, error: errors?.firstName?.message, rules: {
                                            required: {
                                                value: true,
                                                message: "validations.firstNameRequired",
                                            },
                                        } }) }), _jsx(Grid, { size: { xs: 12, sm: 12 }, children: _jsx(HInput, { label: t("formFields.middleName"), name: "middleName", control: control }) }), _jsx(Grid, { size: { xs: 12, sm: 12 }, children: _jsx(HInput, { label: t("formFields.lastName"), name: "lastName", control: control, rules: {
                                            required: {
                                                value: true,
                                                message: "validations.lastNameRequired",
                                            },
                                        }, error: errors?.lastName?.message }) }), _jsx(Grid, { size: { xs: 12, sm: 12 }, children: _jsx(HInput, { label: t("formFields.email"), name: "emailAddress", control: control, rules: {
                                            required: {
                                                value: true,
                                                message: "validations.emailRequired",
                                            },
                                            validate: {
                                                pattern: (value) => {
                                                    const trimmedValue = value.trim();
                                                    return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(trimmedValue)
                                                        || "validations.emailInvalid";
                                                }
                                            }
                                        }, error: errors?.emailAddress?.message, onBlur: (e) => {
                                            e.target.value = e.target.value.trim();
                                        } }) }), _jsx(Grid, { size: { xs: 12, sm: 12 }, children: _jsx(HInput, { label: t("formFields.confirmationemail"), name: "confirmEmail", control: control, rules: {
                                            required: {
                                                value: true,
                                                message: "validations.confirmEmailRequired",
                                            },
                                            validate: (value) => value.trim().toLowerCase() === emailValue || "validations.emailDoesntMatch",
                                        }, error: errors?.confirmEmail?.message, onBlur: (e) => {
                                            e.target.value = e.target.value.trim();
                                        } }) })] })] }), _jsx(PButton, { size: "large", color: "ePrimary", fullWidth: true, endIcon: _jsx(ArrowRightIcon, {}), onClick: handleSubmit(onSubmit), children: t("register.startRegistration") })] }) }));
};
